import {browserHistory} from 'react-router';
import {setState} from '../../Actions/index';

const goToClubTour = () => {
  browserHistory.push(`/club-tour/welcome`);
  return setState();
};

export {goToClubTour};
